import React from 'react';
import './MainSection.css'; // Ensure this is the correct path to your CSS
// import animatedImage from '../assets/lp-image.png'; // Replace with your image path
import sampleVideo from '../assets/feature-video.mp4';

const MainSection = () => {
  const handleDownloadClick = () => {
    // Replace with your published Chrome Web Store URL
    window.open('https://chromewebstore.google.com/detail/eq-of-ai/camegpbfdfbonojgidllkmgiebahmged', '_blank');
  };
  // const handleEQwebsite = () => {
  //   // Replace with your published Chrome Web Store URL
  //   window.open('https://www.innometrixtechub.com/eq-of-ai/', '_blank');
  // };
  
  return (
    <section className="landing-page">
      <div className="main-section">
        <div className="content">
          {/* <p className="title">EQ of AI</p> */}
          <p className="title">Prompt Smartly !!</p>   
          <p className="title"> Secure Privacy !!</p>   
          {/* <p className="title">Reduce Human Errors!! Prevent Cyber Attacks!!</p>   */}
          <p className="subtitle">Stay safe online with real-time protection. Our extension keeps your sensitive information secure, giving you control over your digital privacy with instant alerts and seamless integration.</p>
          {/* <p className="subtitle">Protect Your Data While Using AI Website</p> */}
          <div className="download-button-container">
        <button className="download-button" onClick={handleDownloadClick}>
          <i className="fas fa-download" ></i>Download Now
        </button>
        {/* <button className="demo-button" onClick={handleEQwebsite}>
         Get A Demo
        </button> */}
      </div>
           </div>
           <div className="main-video-section">
         <video className="feature-video" autoPlay muted loop>
        <source src={sampleVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
        {/* <div className="image">
          <img src={animatedImage} alt="Animated representation of AI security" className="animated-image" />
        </div> */}
      </div>
    
    </section>
  );
};

export default MainSection;
